import { render, staticRenderFns } from "./form-generate-transcript.vue?vue&type=template&id=6f43e890&"
import script from "./form-generate-transcript.vue?vue&type=script&lang=js&"
export * from "./form-generate-transcript.vue?vue&type=script&lang=js&"
import style0 from "./form-generate-transcript.vue?vue&type=style&index=0&id=6f43e890&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports